import React, { useMemo } from 'react';
import { FilterOption } from '../../../types';
import { ExposedFiltersTypes, FilterTypes } from '../../../constants/initialFilters';
import { ModelYearListWrapper } from './ModelYearSelector.style';
import CheckboxSelector from '../../CheckboxComponent';
import FilterSection from '../FilterSection';

interface ModelYearSelectorTypes {
  filterType: string;
  modelYearOptions: {
    [key: string]: FilterOption;
  };
  confirmedFilters: FilterTypes;
  availableFilters: Record<string, number>;
  openedFiltersList: ExposedFiltersTypes;
  handleAddFilter: (filterType: string, value: string, isChecked: boolean) => void;
  handleExposeFilter: (arg: string) => void;
}

const ModelYearSelector: React.FC<ModelYearSelectorTypes> = ({
  filterType,
  modelYearOptions,
  confirmedFilters,
  handleAddFilter,
  handleExposeFilter,
  openedFiltersList,
  availableFilters,
}) => {
  const selectedModelYearsList = useMemo(() => {
    const seletedModelYearOptions = confirmedFilters.modelYear;
    return seletedModelYearOptions.map((year) => modelYearOptions[year]?.label)?.join(', ');
  }, [confirmedFilters.modelYear, modelYearOptions]);

  const selectedModelYears = useMemo(() => {
    return confirmedFilters.modelYear;
  }, [confirmedFilters.modelYear]);

  const handleAddModelYearFilter = (newYear: string, isChecked: boolean) => {
    handleAddFilter('modelYear', newYear, isChecked);
  };

  // Sorting year by DESC
  const modelYearsList = Object.keys(modelYearOptions).sort((a, b) => Number(b) - Number(a));

  return (
    <FilterSection
      filterType={filterType}
      selectedFilterLabels={selectedModelYearsList}
      openedFiltersList={openedFiltersList}
      handleExposeFilter={handleExposeFilter}
    >
      <ModelYearListWrapper data-testid="modelYear-list">
        {modelYearsList.map((filterOption) => {
          const option = modelYearOptions[filterOption];
          // is disabled when there is no offer for that model Year
          const isDisabled =
            !Object.keys(availableFilters).includes(option.value.toString()) ||
            !availableFilters[option.value];
          return (
            <CheckboxSelector
              inputName={`${filterType}-${option.value}`}
              key={option.value}
              onChange={() =>
                handleAddModelYearFilter(option.value, selectedModelYears.includes(option.value))
              }
              value={option.value}
              label={option.label}
              ariaLabel={option.ariaLabel}
              checked={selectedModelYears.includes(option.value)}
              disabled={isDisabled}
              hint={isDisabled ? '0' : String(availableFilters[option.value] ?? 0)}
              filterType={filterType}
            />
          );
        })}
      </ModelYearListWrapper>
    </FilterSection>
  );
};

export default ModelYearSelector;
